'use client'
import { useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { OrderStatus } from '@/core/graphql/types'
import { useBooking } from './bookingContext'
import { useOrderManagement } from './useOrderManagement'

const schema = yup.object({
  comment: yup.string().required('Comment is required'),
})

export type ExpertiseInfoFormData = yup.InferType<typeof schema>

export function useExpertiseInfoForm(initialValues?: ExpertiseInfoFormData) {
  return useForm<ExpertiseInfoFormData>({
    defaultValues: initialValues ?? { comment: '' },
    resolver: yupResolver(schema),
    mode: 'all',
  })
}

export function useExpertiseInfoFormSubmit() {
  const { dispatch, state } = useBooking()
  const { submitOrder } = useOrderManagement(state.meetingLinkSlug)

  const [isSubmitting, setIsSubmitting] = useState(false)

  const onSubmit: SubmitHandler<ExpertiseInfoFormData> = async (data: ExpertiseInfoFormData) => {
    try {
      setIsSubmitting(true)
      console.log('🔍 [ORDER TRACKING] ExpertiseInfo handleFormSubmission - Starting with data:', data)
      console.log('🔍 [ORDER TRACKING] ExpertiseInfo handleFormSubmission - Current booking state:', {
        orderId: state.orderId,
        formSubmissionId: state.formSubmissionId,
      })

      // Store expertise data in context
      // dispatch({
      //   type: 'UPDATE_EXPERTISE_DATA',
      //   payload: {
      //     comment: data.comment,
      //     files: uploadedFiles || [],
      //   },
      // })

      // We already have form submission data from the form-submission page
      const payload = {
        comment: data.comment,
        formSubmissionId: state.formSubmissionId, // Use the ID from context
      }

      if (state.orderId) {
        const order = await submitOrder({
          ...payload,
          status: state.requiresPayment ? OrderStatus.Draft : OrderStatus.Pending,
        })
        if (!order) {
          console.error('🔍 [ORDER TRACKING] ExpertiseInfo - Order submission failed, no result returned')
          return
        }
        console.log('🔍 [ORDER TRACKING] ExpertiseInfo - Order submitted successfully, order ID:', order._id)
        // Store order ID in context
        dispatch({ type: 'SET_ORDER_ID', payload: order._id, goToNextStep: true })
      }
    } catch (error) {
      console.error('🔍 [ORDER TRACKING] ExpertiseInfo - Error submitting order:', error)
      dispatch({
        type: 'SET_ERROR',
        payload: { field: 'order', message: 'Failed to submit order' },
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return [onSubmit, isSubmitting] as const
}
